<template>
  <v-dialog class="loading-dialog" v-model="chk_isLoading" fullscreen hide-overlay transition="none">
    <v-container
      fluid
      fill-height
      :style="
        !chk_isLoadingProgress ? 'background-color: rgba(37, 52, 58, 1)' : 'background-color: rgba(37, 52, 58, 0.4)'
      "
    >
      <v-layout v-show="chk_isLoadingProgress" justify-center align-center>
        <!-- <v-progress-circular indeterminate :size="50" color="primary"></v-progress-circular> -->
        <div class="loader-container">
          <!-- <div class="loader"></div> -->
          <div class="box">
            <div class="film"></div>
            <div class="cog">
              <div class="spoke"></div>
              <div class="spoke"></div>
              <div class="spoke"></div>
              <div class="spoke"></div>
              <div class="hole"></div>
            </div>
          </div>
        </div>
      </v-layout>
      <v-layout v-show="!chk_isLoadingProgress" justify-center align-center>
        <!-- <div style="width: 80px; text-align: center">
          <img :src="require('@/assets/img/tape-logo-white.png')" alt="tape logo" class="mr-4" style="width: 80px" />
          <div class="mt-3" style="display: block; color: #eee; font-size: 12px; font-weight: 700">Please wait..</div>
        </div> -->
      </v-layout>
    </v-container>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {}
  },
  computed: {
    chk_isLoading() {
      return this.$store.getters.chk_isLoading ? this.$store.getters.chk_isLoading : false
    },
    chk_isLoadingProgress() {
      return this.$store.getters.chk_isLoadingProgress ? this.$store.getters.chk_isLoadingProgress : false
    },
  },
}
</script>

<style scoped>
.loading-dialog {
  z-index: 9999999999;
}
.loader-container {
  position: fixed;
  z-index: 0;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(37, 52, 58, 0.8);
}
.loader {
  border: 5px solid #f3f3f3;
  border-top: 5px solid #25c685;
  border-radius: 50%;
  width: 56px;
  height: 56px;
  animation: spin2 2s linear infinite;
}

@keyframes spin2 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.loading-text {
  display: inline-block;
  width: 300px;
  position: absolute;
  top: calc(50% + 40px);
  left: calc(50% - 75px);
  z-index: 2;
  color: #ddd;
  text-align: center;
}
.loading-text span {
  display: block;
}
.box {
  display: inline-block;
  position: relative;
  width: 150px;
  height: 150px;
  background-color: #1f2d32;
  overflow: hidden !important;
  border-radius: 30px;
  /* outline: 1px solid #111a1e; */
  z-index: 1;
  top: calc(50% - 85px);
  left: calc(50% - 60px);
  -webkit-mask-image: -webkit-radial-gradient(white, black);
}
.film {
  display: inline-block;
  position: absolute;
  top: calc(50% - 50px);
  right: calc(50% - 120px);
  width: 100px;
  height: 100px;
  background-color: #eee;
  /* overflow: hidden !important; */
  border-radius: 50%;
  z-index: 2;
  animation: border 3s infinite ease-in-out;
}
.spoke {
  background-color: #111a1e;
  position: absolute;
  height: 55px;
  width: 15px;
  margin-left: -8px;
  margin-top: -2px;
  left: 50%;
  z-index: 10;
  border-radius: 5px;
}
.cog {
  position: absolute;
  background-color: #111a1e;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  z-index: 10;
  animation: spin 3s infinite ease-in-out;
  top: 33%;
  right: -25px;
}

.spoke + .spoke {
  transform: rotateZ(45deg);
}

.spoke + .spoke + .spoke {
  transform: rotateZ(-45deg);
}

.spoke + .spoke + .spoke + .spoke {
  transform: rotateZ(90deg);
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes spin2 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}

@keyframes border {
  0% {
    /* outline: 10px solid #111a1e; */
    box-shadow: 0 0 0 10px #111a1e;
  }
  25% {
    /* outline: 30px solid #111a1e; */
    box-shadow: 0 0 0 30px #111a1e;
  }
  50% {
    /* outline: 50px solid #111a1e; */
    box-shadow: 0 0 0 50px #111a1e;
  }
  75% {
    /* outline: 30px solid #111a1e; */
    box-shadow: 0 0 0 30px #111a1e;
  }
  100% {
    /* outline: 10px solid #111a1e; */
    box-shadow: 0 0 0 10px #111a1e;
  }
}
</style>
